import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FaRegCommentDots, FaSignOutAlt, FaUser, FaUserCircle, FaUsers } from "react-icons/fa";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { appNavProfileButtonClass } from "@/components/layout/appNavStyles";
import { useAuth } from "@/context/AuthContext";
import { openFeedbackForm } from "@/lib/services/feedbackService";

export function V2ProfileMenu() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user, signOut } = useAuth();

  const handleSignOut = async () => {
    try {
      await signOut();
      navigate("/");
    } catch (error) {
      console.error("Failed to log out:", error);
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className={appNavProfileButtonClass}
          aria-label={t("v2.profileMenu.account")}
        >
          <FaUserCircle className="h-full w-full" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        {user?.email && (
          <>
            <DropdownMenuLabel className="font-normal text-muted-foreground truncate">
              {user.email}
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
          </>
        )}
        <DropdownMenuItem asChild>
          <Link to="/v2/profile" className="flex items-center gap-2 cursor-pointer">
            <FaUser className="h-4 w-4 text-soccer-primary" />
            {t("nav.profile")}
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link to="/group-selection" className="flex items-center gap-2 cursor-pointer">
            <FaUsers className="h-4 w-4 text-soccer-primary" />
            {t("groups.manageGroups")}
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem
          onSelect={() => openFeedbackForm()}
          className="flex items-center gap-2 cursor-pointer"
        >
          <FaRegCommentDots className="h-4 w-4 text-soccer-primary" />
          {t("profile.giveFeedback")}
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          onSelect={handleSignOut}
          className="flex items-center gap-2 cursor-pointer text-destructive focus:text-destructive"
        >
          <FaSignOutAlt className="h-4 w-4" />
          {t("auth.signOut")}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
